import { createSlice } from "@reduxjs/toolkit";
import { AppStateProps } from "../types";

const initialState: AppStateProps = {
  shouldRefresh: false,
  isAlertOpen: false,
  alertMsg: "",
  severity: "success",
};
const appReducer = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    appRefresh(state, action) {
      return {
        ...state,
        shouldRefresh: action.payload.shouldRefresh,
      };
    },
    showAlert(state, action) {
      return {
        ...state,
        isAlertOpen: action.payload.isAlertOpen,
        alertMsg: action.payload.alertMsg,
        severity: action.payload.severity,
      };
    },
  },
});

export default appReducer.reducer;

export const { appRefresh, showAlert } = appReducer.actions;
